import React, { useEffect, useState } from "react";
import { FaBars, FaUserCircle, FaArrowLeft, FaHome } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/vyapakprints-logo.png";
import { clearAuth, getAuthUser, getToken, isAuthenticated } from "../auth";

const API = "https://api.vyapakprint.com/api";

const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const [user, setUser] = useState(() => {
    const authUser = getAuthUser();
    return authUser?.storedUser || null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        if (!isAuthenticated()) {
          setLoading(false);
          return;
        }

        const token = getToken();
        const authUser = getAuthUser();

        if (!token) {
          setLoading(false);
          return;
        }

        const email =
          authUser?.email ||
          authUser?.storedUser?.email ||
          null;

        const distributionId =
          authUser?.distributionId ||
          authUser?.authUserId ||
          authUser?.storedUser?.distributionId ||
          authUser?.storedUser?.id ||
          null;

        const storedUser = authUser?.storedUser || null;

        if (storedUser) {
          setUser(storedUser);
        }

        const response = await axios.get(`${API}/distribution/`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const raw = response?.data;

        let list = [];
        if (Array.isArray(raw)) {
          list = raw;
        } else if (Array.isArray(raw?.data)) {
          list = raw.data;
        } else if (Array.isArray(raw?.distributions)) {
          list = raw.distributions;
        }

        const matchedUser =
          list.find(
            (item) =>
              distributionId &&
              String(item?._id || item?.id) === String(distributionId),
          ) ||
          list.find(
            (item) =>
              email &&
              String(item?.email || "").toLowerCase() ===
                String(email).toLowerCase(),
          ) ||
          storedUser;

        if (matchedUser) {
          const safeUser = {
            id: matchedUser?._id || matchedUser?.id || storedUser?.id || null,
            _id: matchedUser?._id || matchedUser?.id || storedUser?._id || null,
            distributionId:
              matchedUser?._id ||
              matchedUser?.id ||
              storedUser?.distributionId ||
              null,
            email: matchedUser?.email || storedUser?.email || email || "",
            businessName:
              matchedUser?.businessName || storedUser?.businessName || "",
            contactPerson:
              matchedUser?.contactPerson || storedUser?.contactPerson || "",
            wallet: Number(matchedUser?.wallet ?? storedUser?.wallet ?? 0),
          };

          setUser(safeUser);
          localStorage.setItem("user", JSON.stringify(safeUser));
          localStorage.setItem("distributionUser", JSON.stringify(safeUser));
        }
      } catch (error) {
        console.error("Navbar user load failed:", error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  const handleLogout = () => {
    if (!window.confirm("Are you sure you want to logout?")) return;
    clearAuth();
    navigate("/login", { replace: true });
  };

  const goBack = () => navigate(-1);
  const goHome = () => navigate("/");

  const displayName = user?.contactPerson || "User";
  const businessName = user?.businessName || "Business Account";
  const wallet = Number(user?.wallet || 0);
  const userId = user?._id || user?.id || user?.distributionId || "-";

  return (
    <nav className="border-b bg-white p-3 shadow-sm md:p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {/* LEFT */}
        <div className="flex min-w-0 items-center gap-2 md:gap-3">
          <button
            onClick={toggleSidebar}
            className="rounded-full bg-gray-100 p-2 transition hover:bg-gray-200"
            type="button"
          >
            <FaBars size={18} className="text-gray-700" />
          </button>

          <button
            onClick={goBack}
            className="rounded-full bg-gray-100 p-2 transition hover:bg-gray-200"
            type="button"
          >
            <FaArrowLeft size={16} className="text-gray-700" />
          </button>

          <button
            onClick={goHome}
            className="rounded-full bg-gray-100 p-2 transition hover:bg-gray-200"
            type="button"
          >
            <FaHome size={16} className="text-gray-700" />
          </button>

          <img
            src={logo}
            alt="Vyapakprint"
            className="ml-1 h-8 max-w-[140px] object-contain md:h-10 md:max-w-[180px]"
          />
        </div>

        {/* RIGHT */}
        <div className="flex min-w-0 items-center gap-3 md:gap-4">
          <FaUserCircle size={30} className="shrink-0 text-gray-500" />

          <div className="min-w-0 text-right">
            <p className="truncate text-sm font-semibold text-gray-800">
              Welcome Mr. {displayName}
            </p>
            <p className="truncate text-xs text-gray-500">{businessName}</p>
          </div>

          <div className="hidden text-right text-sm text-gray-700 md:block">
            <p>
              A/C Balance: <span className="font-bold">₹{wallet}</span>
            </p>
            <p>
              USER ID: <span className="font-bold">{userId}</span>
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="ml-1 rounded bg-red-600 px-3 py-2 text-white transition hover:bg-red-500"
            type="button"
          >
            Logout
          </button>
        </div>
      </div>

      {loading && (
        <div className="mt-2 text-xs text-gray-500">Loading account...</div>
      )}
    </nav>
  );
};

export default Navbar;